import { Injectable } from '@angular/core';
import xlsExport from 'xlsexport/xls-export'
import {TranslateService} from '@ngx-translate/core';
import { Observable } from 'rxjs';


@Injectable()
export class XlsFormatService {
    
    constructor(
        private translate: TranslateService
    ) { }
    
    // get translate Headers
    getTranslation(arr) {
        return Observable.forkJoin(
            arr.map(val => this.translate.get(val))
        );
    }

    // get XLS File from arrey
    exportCSVFile(items, filename) {
        const xls = new xlsExport(items, filename);
        xls.exportToXLS(`${filename}.xls`);
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/services/xls-format.service.ts